/* import __COLOCATED_TEMPLATE__ from './delete-account-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();